// extracted by mini-css-extract-plugin
export default {"Collegiom_top_table_child":"Table_Collegiom_top_table_child__8EMbF"};